import { RefObject } from 'react';
import { useShowScrollArrowOnContainer } from '../../../hooks/useShowScrollArrow';
import { SquareArrowDown } from 'lucide-react';

export function ScrollDownArrow({
  containerRef,
  bottomValue
}: {
  containerRef: RefObject<HTMLElement>;
  bottomValue: string;
}) {
  const showArrow = useShowScrollArrowOnContainer(containerRef);
  if (!showArrow) return null;

  return (
    <div
      id="scrollDownArrow"
      className={`sticky bottom-[${bottomValue}] flex justify-end animate-pulse cursor-pointer`}
      style={{ pointerEvents: 'none' }}
    >
      <SquareArrowDown
        color="#56dac5"
        style={{ pointerEvents: 'all' }}
        className="z-index:500"
        size={36}
        onClick={() => {
          if (containerRef.current) {
            console.log('click scroll');
            containerRef.current.scrollBy({
              top:
                containerRef.current.scrollTop +
                containerRef.current.clientHeight,
              behavior: 'smooth'
            });
          }
        }}
      />
    </div>
  );
}
